import { LayoutType } from 'domain/entity/layout';

const BREAKPOINTS_PADDING = 48;

export const A4_PADDING_X = 42;
export const A4_PADDING_Y = 21;

export const BREAKPOINTS = {
    [LayoutType.DESKTOP]: 1200 - BREAKPOINTS_PADDING,
    [LayoutType.TABLET]: 996 - BREAKPOINTS_PADDING,
    [LayoutType.MOBILE]: 768 - BREAKPOINTS_PADDING,
    [LayoutType.A4]: 940,
};
export const CELL_MARGIN = 10;
export const RATIO = 1.5;
export const COLUMNS = {
    [LayoutType.DESKTOP]: 12,
    [LayoutType.TABLET]: 6,
    [LayoutType.MOBILE]: 4,
    [LayoutType.A4]: 12,
};
export const A4_PAGE_HEIGHT = 1366;
export const A4_ROWS_PER_PAGE = 36;
export const A4_HEADER_ROWS = 2;
export const A4_FOOTER_ROWS = 1;
export const A4_CONTENT_START_ROW = A4_HEADER_ROWS;
export const A4_CONTENT_END_ROW = A4_ROWS_PER_PAGE - A4_FOOTER_ROWS - 1;
export const A4_CELL_HEIGHT = (A4_PAGE_HEIGHT - (A4_ROWS_PER_PAGE - 1) * CELL_MARGIN) / A4_ROWS_PER_PAGE;
